import { render, staticRenderFns } from "./outboundOrder.vue?vue&type=template&id=3aa66c1c&scoped=true"
import script from "./outboundOrder.vue?vue&type=script&lang=js"
export * from "./outboundOrder.vue?vue&type=script&lang=js"
import style0 from "./outboundOrder.vue?vue&type=style&index=0&id=3aa66c1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa66c1c",
  null
  
)

export default component.exports